import React from 'react';

import { usePickerActionsContext } from '@mui/x-date-pickers';
import { PickersTextField, PickersTextFieldProps } from '@mui/x-date-pickers/PickersTextField';

export const PickerTextField = React.forwardRef<HTMLDivElement, PickersTextFieldProps>(
  ({ onClick, ...props }, ref): React.ReactElement => {
    const { setOpen } = usePickerActionsContext();

    return (
      <PickersTextField
        {...props}
        ref={ref}
        onClick={(event) => {
          onClick?.(event);
          if ((event.target as HTMLElement).closest('button')) {
            return;
          }
          if (!props.disabled && !props.readOnly) {
            setOpen(true);
          }
        }}
      />
    );
  }
);

export default PickerTextField;
